import { computed, mergeProps, reactive, toValue, unref } from 'vue';

import { EntityPresenterMode } from '@satellite/composables/presenterEntityMode';
import { reactiveOption } from '@satellite/composables/presenterReactiveOption';

import type { ComputedRef, Ref } from 'vue';
import type {
  PresenterDisplayConfigOptions,
  PresenterDisplayOverrideProps
} from '@satellite/composables/presenterDisplayOptions';
import type { YardAreaDetails } from './yardAreaPresenterShared';

export type YardAreaDisplayField = 'name';

export interface UseYardAreaDisplayOptions extends PresenterDisplayConfigOptions {
  nameProps?: PresenterDisplayOverrideProps;
}

export function useYardAreaDisplay(
  area: Ref<YardAreaDetails | null> | ComputedRef<YardAreaDetails | null>,
  options: UseYardAreaDisplayOptions = {}
) {
  const displaySize = reactiveOption(options.size, 'regular');
  const displayMode = reactiveOption(options.mode, EntityPresenterMode.Live);
  const isFetchingValue = computed(() => (options.isFetching ? unref(options.isFetching) : false));

  const name = computed(() => area.value?.name ?? null);

  const nameAttrs = computed(() =>
    mergeProps({ 'data-testid': 'yard-area-presenter-area-name' }, toValue(options.nameProps) ?? {})
  );

  return reactive({
    area,
    mode: displayMode,
    size: displaySize,
    isFetching: isFetchingValue,
    name,
    nameAttrs
  });
}

export type YardAreaDisplayData = ReturnType<typeof useYardAreaDisplay>;
